export default "/images/4d35f848ba27126ab4fe8700783e4d6c.jpg";